import { useState } from 'react';

import { DialogCard, SwipeableViews, makeDialog } from '@cast/design-system';

import { isE2E } from '@cast/utils';

import { FeedbackSlide } from './FeedbackSlide';
import { ProgressSlide } from './ProgressSlide';
import { SetupSlide } from './SetupSlide';
import { useEdgeLocationOffboardingCompleted } from './useEdgeLocationOffboardingCompleted';
import { EnhancedEdgeLocation } from '../../types';

type DialogStep = 'setup' | 'progress' | 'feedback';

type OffboardEdgeLocationDialogProps = {
  edgeLocation: EnhancedEdgeLocation;
  clusterId: string;
};

const OffboardEdgeLocationDialogContent = ({
  edgeLocation,
  clusterId,
}: OffboardEdgeLocationDialogProps) => {
  const [activeSlide, setActiveSlide] = useState<DialogStep>('setup');
  const [feedbackVariant, setFeedbackVariant] = useState<'success' | 'error'>(
    'success'
  );

  useEdgeLocationOffboardingCompleted({
    clusterId,
    edgeLocationId: edgeLocation.id!,
    enabled: activeSlide === 'progress',
    onSuccess: () => {
      setFeedbackVariant('success');
      setActiveSlide('feedback');
    },
    onError: () => {
      setFeedbackVariant('error');
      setActiveSlide('feedback');
    },
  });

  return (
    <DialogCard testId="offboard-edge-location-dialog" size={600}>
      <SwipeableViews
        slides={{
          setup: ({ isActive }) =>
            isActive && (
              <SetupSlide clusterId={clusterId} edgeLocation={edgeLocation} />
            ),
          progress: ({ isActive }) => isActive && <ProgressSlide />,
          feedback: ({ isActive }) =>
            isActive && <FeedbackSlide variant={feedbackVariant} />,
        }}
        disableAnimations={isE2E()}
        activeSlide={activeSlide}
        onSlideChange={(slide) => setActiveSlide(slide)}
      />
    </DialogCard>
  );
};

export const useOffboardEdgeLocationDialog = makeDialog(
  OffboardEdgeLocationDialogContent
);
